import { memo } from 'react';
import { View } from 'react-native';
import { Platform } from 'react-native';
import { Card } from 'tamagui';
import PostDesigner from '../Components/PostDesigner';

interface DesignerTabProps {
  theme: boolean;
  selectedPostData: any;
  handlePostSave: (postData: any) => void;
  handlePostPreview: (postData: any) => void;
  handlePostPublish: (postData: any) => void;
}

const DesignerTab = memo(({
  theme,
  selectedPostData,
  handlePostSave,
  handlePostPreview,
  handlePostPublish,
}: DesignerTabProps) => {
  return (
    <View style={{ flex: 1, padding: Platform.OS === 'web' ? 20 : 16 }}>
      <Card style={{
        borderRadius: 16,
        flex: 1,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 8 },
        shadowOpacity: theme ? 0.1 : 0.3,
        shadowRadius: 20,
        elevation: 10,
        borderWidth: 1,
        backgroundColor: theme ? "#ffffff" : "#1e293b",
        borderColor: theme ? "rgba(0,0,0,0.05)" : "rgba(255,255,255,0.1)",
        padding: 16,
        overflow: "hidden"
      }}>
        <PostDesigner
          initialData={selectedPostData}
          onSave={handlePostSave}
          onPreview={handlePostPreview}
          onPublish={handlePostPublish}
        />
      </Card>
    </View>
  );
});

export default DesignerTab;